import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { AppointmentForm } from '@models/forms/appointment-form';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AppointmentFormService {
  constructor(private http: HttpClient) {}

  updateAppointmentForm(appointmentTreatmentForm: AppointmentForm, submission: any) {
    let submissionData = submission.data;
    if (submission.dateTime) {
      submission.dateTime = new Date().toISOString();
    }
    appointmentTreatmentForm.formEntry = JSON.stringify({
      data: submissionData,
      metadata: { timezone: Intl.DateTimeFormat().resolvedOptions().timeZone },
    });

    let packageJson = require('./../../../package-lock.json');
    appointmentTreatmentForm.rendererVersion = packageJson['packages']['node_modules/@formio/angular']['version'];

    return this.http
      .put<AppointmentForm>(environment.baseUrl + 'api/AppointmentForms', appointmentTreatmentForm)
      .pipe(tap((form) => {}));
  }
}
